<template>
  <el-breadcrumb
    class="app-breadcrumb"
    separator="/"
    :class="{
      isChild:isChild
    }"
  >
    <span class="border" />
    <svg-icon
      icon-class="back"
      class="icon"
      @click="back"
    />
    <!--    <transition-group name="breadcrumb">-->
    <el-breadcrumb-item :key="0" class="title">
      {{ $route.meta.title }}
    </el-breadcrumb-item>
    <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
      <span v-if="item.redirect==='noRedirect'||index==levelList.length-1" class="no-redirect">{{ item.meta.title }}</span>
      <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
    </el-breadcrumb-item>
    <!--    </transition-group>-->
  </el-breadcrumb>
</template>

<script>
import pathToRegexp from 'path-to-regexp'
export default {
  name: 'UmBreadCrumb',
  props: {},
  data() {
    return {
      levelList: null,
      route: {}
    }
  },
  computed: {
    isChild() {
      if (this.$route.meta && this.$route.meta.activeMenu) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith('/redirect/')) {
        return
      }
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  mounted() {},
  methods: {
    back() {
      // this.$router.back()
      const route = this.$route
      if (route.meta.activeMenu) {
        this.$router.replace(route.meta.activeMenu)
      } else {
        this.$router.go(-1)
      }
    },
    getBreadcrumb() {
      const matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
    },
    isDashboard(route) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return name.trim().toLocaleLowerCase() === 'Dashboard'.toLocaleLowerCase()
    },
    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const { params } = this.$route
      console.log(pathToRegexp)
      var toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    handleLink(item) {
      const { redirect, path } = item
      if (redirect) {
        if (typeof redirect === 'function') {
          this.$router.push(redirect())
        } else {
          this.$router.push(redirect)
        }
        return
      }
      this.$router.push(this.pathCompile(path))
    }
  }
}
</script>

<style lang="scss" >
.app-breadcrumb.el-breadcrumb {
  user-select:none;
  height: 50px;
  margin-left: 8px;
  font-size: 0;
  position: relative;
  margin-top: -20px;
  &.isChild{
    .border{display: none;}
    .icon{display: block;}
  }
  .border{
    display: block;
    float: left;
    margin-right: 5px;
    margin-top: 15px;
    width:5px;
    height:16px;
    background:rgba(43,111,239,1);
    box-shadow:0px 1px 4px 0px rgba(121,164,244,1);
    border-radius:3px;
  }
  .icon{
    display: none;
    float: left;
    color:rgba(43,111,239,1);
    font-size: 16px;
    margin-top: 15px;
    margin-right: 5px;
    cursor: pointer;
  }
  .el-breadcrumb__item{
    font-size: 12px;
    height: 50px;
    line-height: 50px;
    .el-breadcrumb__inner{
      line-height: 1;
    }
    &.title{
      .el-breadcrumb__inner{
        font-size:16px;
        color:#333;
        font-weight:500 !important;
      }
      .el-breadcrumb__separator{
        opacity: 0;
      }
    }
  }
  .no-redirect {
    color: #999999;
    cursor: text;
  }
  .el-breadcrumb__separator{
    margin:0 2px;
  }
}
</style>
